(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-section"] && !window.DesignMode) return;
  try {
    

  	

document.querySelectorAll('.klaviyo_form_cf').forEach((ContactFormOptionBlocks) => {
  ContactFormOptionBlocks.style.display = 'none';
});  
document.querySelector('.klaviyo_form_tracking').style.display = 'block';  
  
document.querySelectorAll('#ContactFormOption').forEach((ContactFormOptionSummary) => {

  ContactFormOptionSummary.addEventListener('change', (event) => {
    //alert("change"+event.currentTarget.value);
      document.querySelectorAll('.klaviyo_form_cf').forEach((ContactFormOptionBlocks) => {
        ContactFormOptionBlocks.style.display = 'none';
      });    
      event.currentTarget.closest('.contact-boxcontainer-outer').querySelectorAll('.klaviyo_form_'+event.currentTarget.value)[0].style.display = 'block';
  
  });

});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module-faq"] && !window.DesignMode) return;
  try {
    
(function() {
  $('body').on('click', '.shopify_explorer_faq__question', function() {
    $('.shopify_explorer_faq__answer').slideUp(500);
	if($('.shopify_explorer_faq__question').hasClass('active'))
		$('.shopify_explorer_faq__question').removeClass('active');
    $(this).next('.shopify_explorer_faq__answer').slideToggle(500).toggleClass('active');
    $(this).toggleClass('active');

  });
  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
  	$(event.target).find('.shopify_explorer_faq__answer').slideDown(500);
  });
  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
  	$(event.target).find('.shopify_explorer_faq__answer').slideUp(500);
	$(event.target).find('.shopify_explorer_faq__question').removeClass('active');
  });
}());

  } catch(e) { console.error(e); }
})();
})();
